export default function Testimonials() {
    const items = [
        {
            quote: "I came in with a PCOS diagnosis and a folder of normal-looking reports. Dr. Ishani read between the lines, restored my cycle, and quietly returned my labs to baseline in six months.",
            name: "S. R.",
            meta: "Reversal pathway · Bengaluru",
        },
        {
            quote: "I’ve worked with three longevity practitioners. Only Dr. Hanspal’s team built a protocol I could actually live — and showed me the numbers as they moved.",
            name: "A. K.",
            meta: "Longevity pathway · Gurugram",
        },
        {
            quote: "She treats medicine like architecture — every recommendation has a load-bearing reason behind it. My HbA1c is back in range for the first time in nine years.",
            name: "V. M.",
            meta: "Reversal pathway · Chennai",
        },
    ];

    return (
        <section
            className="relative text-[hsl(var(--bg-chalk))]"
            style={{
                background:
                    "radial-gradient(60% 80% at 80% 0%, hsl(var(--brand-gold) / 0.32) 0%, transparent 55%), radial-gradient(60% 80% at 0% 100%, hsl(var(--brand-gold) / 0.18) 0%, transparent 55%), hsl(var(--brand-ink-deep))",
            }}
        >
            <div className="ihx-container py-20 lg:py-28">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
                    <div className="lg:col-span-7">
                        <span className="ihx-eyebrow" style={{ color: "hsl(var(--brand-gold-soft))" }}>Patient Stories</span>
                        <h2 className="font-serif text-[hsl(var(--bg-chalk))] text-[38px] md:text-[52px] leading-[1.02] mt-5 max-w-2xl tracking-[-0.02em]">
                            Quiet outcomes, <span className="ihx-italic" style={{ color: "hsl(var(--brand-gold))" }}>measured carefully.</span>
                        </h2>
                    </div>
                    <p className="lg:col-span-5 text-[hsl(var(--bg-chalk))]/70 text-[15px] leading-[1.7]">
                        Names are abbreviated for privacy. Patients shared their stories with
                        consent and have remained under continuous care.
                    </p>
                </div>

                <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-5">
                    {items.map((t) => (
                        <figure
                            key={t.name}
                            className="ihx-glass-card p-7 md:p-8 flex flex-col"
                            style={{
                                backgroundColor: "hsl(var(--bg-white-warm) / 0.08)",
                                borderColor: "hsl(var(--bg-chalk) / 0.15)",
                            }}
                        >
                            <span
                                aria-hidden
                                className="font-serif italic text-[58px] leading-none -mb-2"
                                style={{ color: "hsl(var(--brand-gold))" }}
                            >
                                “
                            </span>
                            <blockquote className="text-[15.5px] leading-[1.7] text-[hsl(var(--bg-chalk))]/88 flex-1">
                                {t.quote}
                            </blockquote>
                            <figcaption className="mt-8 pt-5 border-t border-[hsl(var(--bg-chalk))]/15">
                                <div className="font-serif text-[16px] text-[hsl(var(--bg-chalk))]">{t.name}</div>
                                <div className="text-[11.5px] tracking-[0.18em] uppercase text-[hsl(var(--bg-chalk))]/55 mt-1">
                                    {t.meta}
                                </div>
                            </figcaption>
                        </figure>
                    ))}
                </div>
            </div>
        </section>
    );
}
